import { Component, input } from '@angular/core';
import { CropSoilAnalysis, CropSoilAnalysisKey } from 'src/app/bem/shared/models/models';

@Component({
    selector: 'app-lab-result-column',
    template: `
    <div class="column-container">
      @if (data()) {
        @if (isPlant()) {
          <div class="plant-values">
            @for (param of plantParameters; track param) {
              <div class="value-item">
                <div class="right-align">{{ (data()?.[param] ?? 0).toFixed(1) }}</div>
              </div>
            }
          </div>
        } @else {
          <div class="soil-values">
            @for (param of soilParameters; track param) {
              <div class="value-item">
                <span class="right-align">{{ (data()?.[param] ?? 0).toFixed(1) }}</span>
              </div>
            }
          </div>
        }
      }
    </div>`,
    styleUrl: '../../crop-soil-analysis-block.component.scss',
})
export class CropSoilAnalysisColumnComponent {
  isPlant = input<boolean>();
  data = input<CropSoilAnalysis>();
  hasSoilNitrate = input<boolean>();
  plantParameters: CropSoilAnalysisKey[] = [
    'nNo3PlantMgl',
    'kPlantMgl',
    'mnPlantMgl',
    'leafWeight',
    'nO3Norm',
  ];


  get soilParameters(): CropSoilAnalysisKey[] {
    const params: CropSoilAnalysisKey[] = [];
    if (this.hasSoilNitrate()) {
      params.push('nMinKgha');
    }

    params.push(
      'kSoilKgha',
      'mgSoilKgha',
      'mnSoilKgha',
      'bSoilKgha',
      'sSoilKgha',
    );

    return params;
  }
}
